export const CONVERSATIONS_LOAD_START = 'CONVERSATIONS_LOAD_START';
export const CONVERSATIONS_LOAD_SUCCESS = 'CONVERSATIONS_LOAD_SUCCESS';
export const CONVERSATIONS_LOAD_FAILURE = 'CONVERSATIONS_LOAD_FAILURE';
export const CONVERSATIONS_SET_UNREAD_COUNT = 'CONVERSATIONS_SET_UNREAD_COUNT';
export const CONVERSATIONS_PAGINATION_LOAD_SUCCESS = 'CONVERSATIONS_PAGINATION_LOAD_SUCCESS';
export const CONVERSATIONS_LOAD_ONE = 'CONVERSATIONS_LOAD_ONE';
export const CONVERSTATIONS_UNREAD_MESSAGES_LOAD_START =
  'CONVERSTATIONS_UNREAD_MESSAGES_LOAD_START';
export const CONVERSATIONS_UNREAD_MESSAGES_LOAD_FAILURE =
  'CONVERSATIONS_UNREAD_MESSAGES_LOAD_FAILURE';
